// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>175</span>&nbsp;&nbsp;Let my soul live and it shall praise you,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and let your judgements be my help.<br> </p> </div></div>";
// Exports
module.exports = code;